/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import  { useEffect, useRef, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
// import Logo from '../images/logo/logo.png';
// import SidebarLinkGroup from './SidebarLinkGroup';
import * as Icon from 'lucide-react';
import Select from 'react-select';
import { getAllFilterEmployee } from '../../services/applicationService';

const Sidebar = ( {sidebarOpen, setSidebarOpen,formik,isLoading,setCurrentPage,filterData } ) => {
  const location = useLocation();
  const { pathname } = location;
  // const filterData = useSelector((state) => state.filter.filters)
  const trigger = useRef(null);
  const sidebar = useRef(null);
  const  [employerData,setEmployerData]= useState([])
  const  [employee,setEmployee]= useState([])


  const storedSidebarExpanded = localStorage.getItem('sidebar-expanded');
  const [sidebarExpanded, setSidebarExpanded] = useState(
    storedSidebarExpanded === null ? false : storedSidebarExpanded === 'true'
  );

  // close on click outside
  useEffect(() => {
    getDefaultEmployee()
    const clickHandler = (target) => {
      // Check if target is a valid DOM element (Node)
      if (!(target instanceof Node)) return;
    
      if (!sidebar.current || !trigger.current) return;
    
      if (
        !sidebarOpen ||
        sidebar.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
    
      setSidebarOpen(false);
    };

    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  }, [sidebarOpen, setSidebarOpen, sidebar, trigger]);
   // Adding dependencies here
useEffect(()=>{
  setEmployerData(filterData?.employer?.slice(0,50))
},[filterData])

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ( keyCode ) => {
      if (!sidebarOpen || keyCode !== 27) return;
      setSidebarOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });

  useEffect(() => {
    localStorage.setItem('sidebar-expanded', sidebarExpanded.toString());
    if (sidebarExpanded) {
      document.querySelector('body')?.classList.add('sidebar-expanded');
    } else {
      document.querySelector('body')?.classList.remove('sidebar-expanded');
    }
  }, [sidebarExpanded]);


  const getDefaultEmployee = async (data) => {
    console.log(data,'sdasdsssssss')
    const result = await getAllFilterEmployee(data);
    if (result?.status) {
      setEmployee(result.data);
    } else {
    }
  };

  return (
    <aside
      ref={sidebar}
      className={`absolute  h-screen max-w-80 left-0 top-0 z-[9999] flex  flex-col overflow-y-hidden bg-primary duration-300 ease-linear dark:bg-boxdark lg:static lg:translate-x-0 ${
        sidebarOpen ? 'translate-x-0' : '-translate-x-full'
      }`}
    >
      {/* <!-- SIDEBAR HEADER --> */}
      <button
          ref={trigger}
          onClick={() => setSidebarOpen(!sidebarOpen)}
          aria-controls="sidebar"
          aria-expanded={sidebarOpen}
          className="block lg:hidden absolute right-0 text-white"
        >
          <Icon.ArrowLeftToLine size={30}/>
        </button>
      {/* <!-- SIDEBAR HEADER --> */}

      <div className="no-scrollbar flex flex-col overflow-y-auto duration-300 ease-linear">
        {/* <!-- Sidebar Menu --> */}
        <div className="h-full p-2">
      
          <form onSubmit={formik.handleSubmit} className='space-y-3'>
         
      
       
         <div>
         <label className="block  text-sm font-medium text-white">
       Year
      </label>
  
      <Select
      
         name="years"
         value={formik.values.years?.map(year => ({ value: year, label: year }))}
        isMulti
        onChange={(selectedOptions) => {
          const values = selectedOptions?.map(option => option.value);
          formik.setFieldValue('years', values);
        }}
        
        placeholder="Select Year"
        isLoading={isLoading}
    
       
        options={[
          { value: "All", label: "All" },
          ...(filterData?.year || []) // Check if filterData?.year exists before mapping
        ]}  />
    
         </div>
  {/* filter box start 2 */}
            {/* filter box start 1 */}
         <div>
         <label
        htmlFor="email"
        className="block  text-sm font-medium text-white"
      >
       Quater
      </label>
    
      <Select
         name="quarters"
         value={formik.values.quarters?.map(quarters => ({ value: quarters, label: quarters }))}
        isMulti
        onChange={(selectedOptions) => {
          const values = selectedOptions?.map(option => option.value);
          formik.setFieldValue('quarters', values);
        }}
        placeholder="Select Quater"
        isLoading={isLoading}
        options={[
          { value: "All", label: "All" },
          ...(filterData?.quarter|| []) // Check if filterData?.year exists before mapping
        ]} 
       

      />
         </div>
  {/* filter box start 2 */}
            {/* filter box start 1 */}
         <div>
         <label
      
        className="block  text-sm font-medium text-white"
      >
       Program Stream
      </label>
    
      <Select
         name="program_streams"
         value={formik.values.program_streams?.map(program_streams => ({ value: program_streams, label: program_streams }))}
         isMulti
         onChange={(selectedOptions) => {
           const values = selectedOptions?.map(option => option.value);
           formik.setFieldValue('program_streams', values);
         }}
        placeholder="Select Program Stream"
        isLoading={isLoading}
    
        options={[
          { value: "All", label: "All" },
          ...(filterData?.program_stream|| []) // Check if filterData?.year exists before mapping
        ]} 
      
      />
      

         </div>
  {/* filter box start 2 */}
            {/* filter box start 1 */}
         <div>
         <label
      
        className="block  text-sm font-medium text-white"
      >
       Province
      </label>
      <Select
         name="provinces"
         value={formik.values.provinces?.map(provinces => ({ value: provinces, label: provinces }))}
         isMulti
         onChange={(selectedOptions) => {
           const values = selectedOptions?.map(option => option.value);
           formik.setFieldValue('provinces', values);
         }}
        placeholder="Select Province"
        isLoading={isLoading}
    
        options={[
          { value: "All", label: "All" },
          ...( filterData?.province || []) // Check if filterData?.year exists before mapping
        ]}  
        
      />
         </div>
  {/* filter box start 2 */}
            {/* filter box start */}
         <div>
         <label
      
        className="block  text-sm font-medium text-white"
      >
       City
      </label>
      <Select
         name="cities"
         value={formik.values.cities?.map(cities => ({ value: cities, label: cities }))}
         isMulti
         onChange={(selectedOptions) => {
           const values = selectedOptions?.map(option => option.value);
           formik.setFieldValue('cities', values);
         }}
        placeholder="Select City"
        isLoading={isLoading}
    
        options={[
          { value: "All", label: "All" },
          ...( filterData?.city || []) // Check if filterData?.year exists before mapping
        ]}  
       
      />
         </div>
  {/* filter box end  */}

   {/* filter box start */}
         <div>
         <label
      
        className="block  text-sm font-medium text-white"
      >
        Employer
       
      </label>
     <Select
  name="employers"
  value={formik.values.employers?.map(cities => ({ value: cities, label: cities }))}
  isMulti
  onChange={(selectedOptions) => {
    console.log(selectedOptions,'selectedOptions')
    const values = selectedOptions?.map(option => option.value);
    formik.setFieldValue('employers', values);
  }}
  onInputChange={(inputValue) => {
    console.log("Input value is:", inputValue);
    getDefaultEmployee(inputValue);
  }}
  getValue={(e) => {
    console.log("the value is", e);
  }}
  placeholder="Select Employer"
  isLoading={isLoading}
  options={employee.map(e => ({ value: e?.employer, label: e?.employer })) || []}
/>
         </div>
  {/* filter box end  */}
   {/* filter box start */}
   <div>
    <label key="status" className="block text-sm font-medium text-white">
        Status
    </label>

    <select
        name="statuses"
        value={formik.values.statuses}
        onChange={formik.handleChange}
        placeholder="Select Status" // This line should work
       className='w-full rounded '

     
    >

<option disabled selected value="" >Select Status</option>
      {filterData?.status?.map((e) => (
          <option value={e.value}>{e.value}</option>
      ))} 
        <option value="All">All</option>
      </select>
</div>

  {/* filter box end  */}
   {/* filter box start */}
         <div>
         <label
      
        className="block  text-sm font-medium text-white"
      >
      NOC 
      </label>
      <Select
         name="nocs"
         value={formik.values.nocs?.map(nocs => ({ value: nocs, label: nocs }))}
         isMulti
         onChange={(selectedOptions) => {
           const values = selectedOptions?.map(option => option.value);
           formik.setFieldValue('nocs', values);
         }}
        
        placeholder="Select NOC "
        isLoading={isLoading}
        options={[
          { value: "All", label: "All" },
          ...(filterData?.noc_code || []) // Check if filterData?.year exists before mapping
        ]} 
       
      />
         </div>
  {/* filter box end  */}
       
  <button
      type="submit"
      className="bg-black hover:bg-info/90 text-white block py-4 px-4 text-center w-full font-imprima "
      onClick={()=>setCurrentPage(1)}
    >
     Search
     
    </button>
          </form>
        </div>
        {/* <!-- Sidebar Menu --> */}
      </div>
    </aside>
  );
};

export default Sidebar;
